import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconFolder = props => (
  <SvgIcon {...props} viewBox="0 0 20 15.8501">
    <path d="m18 1.9813h-8l-2-1.9813h-6c-1.1 0-1.99 0.89157-1.99 1.9813l-0.01 11.888c0 1.0897 0.9 1.9813 2 1.9813h16c1.1 0 2-0.8916 2-1.9813v-9.9065c0-1.0897-0.9-1.9812-2-1.9812zm0 11.888h-16v-9.9063h16v9.9063z" />
  </SvgIcon>
);

export default IconFolder;



// WEBPACK FOOTER //
// ./src/components/icons/IconFolder.js